module.exports = __webpack_public_path__ + "static/media/7.ece45900.gif";